import { Dialog, DialogContent, makeStyles, useTheme } from "@material-ui/core";
import React from 'react';
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { TablaSuper } from "../../../alcoholimetro/component/tableSupervisor";

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        color: '#2196F3',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
}));

export const ModalSupervisores = ({ setopenMondal, isOpen, data, listDepartamentos, listMunicipio, handledMunicipios, reload }) => {
    const classes = useStyles();

    const clearData = () => {
        setopenMondal(false)
    }

    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} className={classes.title} style={{ color: primaryColor }} >
                        Supervisores {data.name}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        <TablaSuper data={data} />
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}